module.exports = __webpack_public_path__ + "img/falando.ac1083ec.png";